import { type ProductOfferFragment } from '@/services/graphql/generated'
import type { PriceIntent } from '@/services/priceIntent/priceIntent.types'
import type { ShopSession } from '@/services/shopSession/ShopSession.types'
import { BUNDLE_DISCOUNT_CAMPAIGN_CODE } from './bundleDiscount.constants'

export const getBundleDiscountOnCurrentOffer = (offer: Pick<ProductOfferFragment, 'cost'>) => {
  return offer.cost.discountsV2.find(({ itemDiscount }) => itemDiscount.campaignCode === BUNDLE_DISCOUNT_CAMPAIGN_CODE)
}

export const hasCartItemsEligibleForBundleDiscount = (shopSession: ShopSession) => {
  return (shopSession.cart.bundleDiscount.eligibleProductCount ?? 0) >= 1
}

export const isExistingMember = (shopSession: ShopSession) => {
  // We don't have an explicit way to differentiate between existing and new members.
  // That's by design because we don't want to expose that. An alternative way to check that,
  // which was added as part of bundle discount feature, is to rely on 'shopSession.cart.bundleDiscount.eligibleProductCount'
  // field. Storefront will set it to null for existing members.
  return shopSession.cart.bundleDiscount.eligibleProductCount == null
}

export const shouldShowAccidentDisclaimer = (shopSession: ShopSession, priceIntent?: PriceIntent) => {
  const hasAccidentInTheCart = shopSession.cart.items.some((item) => item.productOffer.product.name === 'SE_ACCIDENT')
  const isQuotingAccident = priceIntent?.product.name === 'SE_ACCIDENT' && priceIntent?.offers.length > 0

  return hasAccidentInTheCart || isQuotingAccident
}
